/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamAgentFailoverRequestCause } from './oralExamAgentFailoverRequestCause';
import type { OralExamAgentFailoverRequestReason } from './oralExamAgentFailoverRequestReason';
import type { OralExamAgentFailoverRequestDispatchGeneration } from './oralExamAgentFailoverRequestDispatchGeneration';

/**
 * Machine-only failover body from the Nexus examiner worker.
 */
export interface OralExamAgentFailoverRequest {
  tenantId: string;
  cause?: OralExamAgentFailoverRequestCause;
  reason?: OralExamAgentFailoverRequestReason;
  dispatchGeneration?: OralExamAgentFailoverRequestDispatchGeneration;
}
